import { MODULE_NAV } from "./registry";

/**
 * Quyen de VAO mot module (bat ky ma nao khop). `x.*` = moi quyen bat dau bang `x.`.
 *
 * Co tinh rong hon the o cong ung dung (`APPS`, chi xet `portal.*`): ai co quyen
 * chuc nang ma API dung (vd `nhanhvn.view`) van vao duoc qua link — chan nham nguoi
 * dang dung hop le con te hon de lot. Muc nao chat hon thi khai `permissions` o
 * chinh muc do trong `MODULE_NAV`. Module khong co trong bang = khong chan.
 */
export const MODULE_ACCESS: Readonly<Record<string, readonly string[]>> = {
  tmdt: ["portal.tmt", "tiktok.*", "cskh.*", "thht.*"],
  tiktok: ["portal.tmt", "tiktok.*"],
  cskh: ["cskh.*"],
  thht: ["thht.*"],
  cleaning: ["portal.checklist", "cleaning.*"],
  hr: ["portal.hr", "hr.*", "rbac.manage"],
  voucher: ["portal.voucher", "voucher.*"],
  cashflow: ["portal.cashflow", "cashflow.*"],
  cash_qr: ["portal.cash_qr", "portal.cashflow", "cash_qr.*"],
  shipping_weight: ["portal.shipping_weight", "shipping_weight.*"],
  kol: ["portal.kol", "kol.*"],
  disbursement: ["portal.disbursement", "disbursement.*"],
  nhanhvn: ["portal.nhanhvn", "nhanhvn.*"],
  auditlog: ["portal.audit", "audit.*"],
};

export interface AccessUser {
  permissions: readonly string[];
  isStaff: boolean;
  isSuperuser: boolean;
}

/** Co BAT KY quyen trong `anyOf` (ho tro `x.*`); superuser / staff luon co (giong PermissionGuard). */
export function hasAnyPermission(user: AccessUser, anyOf: readonly string[]): boolean {
  if (user.isSuperuser || user.isStaff) return true;
  const perms = new Set(user.permissions);
  return anyOf.some((code) =>
    code.endsWith(".*") ? user.permissions.some((p) => p.startsWith(code.slice(0, -1))) : perms.has(code),
  );
}

export type RouteAccess = { ok: true } | { ok: false; feature: string };

/**
 * Trang cua module `moduleKey` (muc dang xem `activeHref`) co vao duoc khong:
 * 1. qua cua module (`MODULE_ACCESS`);
 * 2. neu `checkItem`: muc sidebar trung `activeHref` (bo `#…`) co khai `permissions`
 *    thi phai co mot quyen trong do. Trang con / chi tiet dung `activeHref` cua muc
 *    cha nen ke thua luon.
 * Khong qua → `feature` (ten muc / ten module) de hien tren trang /403.
 */
export function routeAccess(moduleKey: string, activeHref: string, user: AccessUser, checkItem = true): RouteAccess {
  const mod = MODULE_NAV[moduleKey];
  const gate = MODULE_ACCESS[moduleKey];
  const base = (href: string) => href.split("#")[0];
  const item = checkItem ? mod?.items.find((i) => base(i.href) === base(activeHref)) : undefined;
  if (gate && !hasAnyPermission(user, gate)) return { ok: false, feature: mod?.name ?? moduleKey };
  if (item?.permissions?.length && !hasAnyPermission(user, item.permissions)) return { ok: false, feature: item.label };
  return { ok: true };
}

/** Duong dan trang "Khong co quyen truy cap" kem ten tinh nang. */
export const forbiddenHref = (feature: string) => `/403?feature=${encodeURIComponent(feature)}`;
